<template>
  <!--关于我们页面-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
      <!--      <div class="imgText">
              <div>产品介绍</div>
              <div>YAG激光治疗仪YAG激光治疗仪YAG激光治疗仪YAG</div>
            </div>-->
    </div>

    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <!--    内容-->
    <div class="contentBox" v-show="showData.box1">
      <el-row :gutter="10" class="row_1">
        <el-col :span="6"><div class="grid-content"><p class="pp1">{{itemData.pptext.text1}}</p></div></el-col>
        <el-col :span="18"><div class="grid-content"><p class="pp2">{{itemData.pptext.text2}}</p></div></el-col>
      </el-row>
      <el-row :gutter="10" class="row_1">
        <el-col :span="6"><div class="grid-content"> </div></el-col>
        <el-col :span="18" :offset="6"><div class="grid-content"><p class="pp3">{{itemData.pptext.text3}}</p></div></el-col>
      </el-row>
      <div class="count3">
        <div class="p4" v-for="item in itemData.cpbuLsit" >
          <div class="p_top">
            <div class="sp1">{{item.text1}}</div>
            <div class="sp2">{{item.text2}}</div>
          </div>
          <div class="p_buttom">
            <div class="sp3">{{item.text3}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="contentBox"  v-show="showData.box2">
      <el-timeline>
        <el-timeline-item placement="top" v-for="item in itemData.c2DataList">
          <div>
            <p class="c2_p1">{{item.text1}}</p>
            <p class="c2_p2">{{item.text2}}</p>
            <p class="c2_p3"  v-if="item.text3 != ''">{{item.text3}}</p>
            <el-image
              v-if="item.url != ''"
              style="width: 360px; height: 180px"
              :src="item.url"
              :fit="contain"></el-image>
          </div>
        </el-timeline-item>

      </el-timeline>
    </div>

    <div class="contentBox" v-show="showData.box3" >

      <div class="count_3">
        <p class="c3_p1" v-for="item in itemData.c3Data.c3P">{{item.text1}}</p>
      </div>
      <div class="count3">
        <div class="p4" v-for="item in itemData.c3Data.c3w" >
          <div class="p_top">
            <div class="sp1">{{item.text1}}</div>
            <div class="sp2">{{item.text2}}</div>
          </div>
          <div class="p_buttom">
            <div class="sp3">{{item.text3}}</div>
          </div>
        </div>
      </div>
      <div class="c3_img" v-for="itemall in itemData.c3Data.c3Img">
        <div class="c3_img2" v-for="item in  itemall.imgItem">
          <img
            class="c3_img2_1"
            :src="item.url" ></img>

          <p v-if="item.text1 != ''" class="c3_p2">{{item.text1}}</p>
        </div>
      </div>
    </div>

    <div class="contentBox"  v-show="showData.box4">
      <div class="c4_ren" v-for="item in itemData.c4Data">
        <div class="c4_ren_img">
          <el-image
            style="width: 384px; height: 360px"
            :src="item.imgUrl"
            :fit="contain"></el-image>
        </div>
        <div class="c4_ren_text">
          <div class="c4_ren_d1">
            <p class="C4_p1">{{item.text1}}</p>
          </div>
          <div>
            <p class="C4_p2">{{item.text2}}</p>
            <p class="C4_p2">{{item.text3}}</p>
            <p class="C4_p2">{{item.text4}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="contentBox" v-show="showData.box5">
      <div class="c5_sm" v-for="item in itemData.c5Data">
        <div class="c5_sm_1">
          <div class="c5_sm_p1">{{item.text1}}</div>
          <div class="c5_sm_p2">{{item.text2}}</div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>

import {Data} from "./js/aboutUs";

export default {
  name: "product",
  data() {
    return {

      urlData:"",
      showData:{
        box1: false,
        box2: false,
        box3: false,
        box4: false,
        box5: false
      },
      numIndex: "1",
      dataAll: Data,
      itemData: {},

    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  mounted() {
    let that = this;
    console.log("init");
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
    that.init();
  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'gsjj')
      } else {
        let index = "1";
        if(that.urlData == 'gsjj'){
          index = "1";
        } else if (that.urlData == 'fzlc'){
          index = "2";
        } else if (that.urlData == 'hxys'){
          index = "3";
        } else if (that.urlData == 'tdcy'){
          index = "4";
        } else if (that.urlData == 'yjsm'){
          index = "5";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;
      that.showData.box2= false;
      that.showData.box3 = false;
      that.showData.box4 = false;
      that.showData.box5 = false;

      if(index == '1'){
        that.showData.box1 = true;
      } else if (index == '2'){
        that.showData.box2 = true;
      } else if (index == '3'){
        that.showData.box3 = true;
      } else if (index == '4'){
        that.showData.box4 = true;
      } else if (index == '5'){
        that.showData.box5 = true;
      }
    }
  }

}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.c5_sm_p1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  text-align: left;
}
.c5_sm_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0;
  text-align: justify;
  line-height: 20px;
}
.c5_sm_1{
  width: 58.25%;
  aspect-ratio: 685/64;
  margin-left: 30px;

}
.c5_sm{
  width: 100%;
  aspect-ratio: 1176/148;
  background-color: #FFFFFF;
  border-left: 3px solid #5daf34 ;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
}
.c4_ren_d1{
  margin-bottom: 20px;
}
.C4_p1{
  font-family: SourceHanSansCN;
  font-size: 24px;
  text-align: left;
}
.C4_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0;
  text-align: justify;
  margin-bottom: 5px;
}
.c4_ren_text{
  width: 663px;
  height: 253px;
  margin: 50px auto;
}
.c4_ren{
  display: flex;
  width: 1176px;
  height: 360px;
  margin-bottom: 50px;
  border:1px #a6a9ad solid;
}
.c3_img2_1{
  width: 100%;
  aspect-ratio: 376/483;
}
.c3_img2{
  margin-right: 15px;
  width: 31.97%;
}
.c3_img{
  display: flex;
  width: 100%;
}
.count_3{
  width: 100%;
  aspect-ratio: 1176/125;
}
.c3_p2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.c3_p1{
  font-family: SourceHanSansCN;
  font-size: 18px;
  letter-spacing: 0.39px;
  text-align: left;
  margin-top: 10px;
}
.c2_p1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #63B62E;
  letter-spacing: 0.77px;
  text-align: left;
}
.c2_p2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.39px;
  text-align: left;
}
.c2_p3{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0.3px;
  text-align: left;
}
.p4{
  width: 14.54%;
  aspect-ratio: 171/152;
  margin-right: 100px;
}
.p_top{
  display: flex;
}
.count3{
  display: flex;
  margin-top: 100px;
}
.sp1{
  font-family: SourceHanSansCN;
  font-size: 100px;
  color: #63B62E;
  letter-spacing: 2.14px;
  text-align: justify;
}
.c3_img{
  margin-top: 50px;
}
.sp2{
  font-family: SourceHanSansCN;
  font-size: 40px;
  color: #63B62E;
  letter-spacing: 0.86px;
  text-align: justify;
}
.sp3{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.3px;
  text-align: center;
}
.row_1{
  margin: 30px auto;
}
.p1{
  width: 30%;
  margin: 50px auto;
  justify-content: start; /* 水平居中 */
  align-items: start;
}
.pp1{
  font-family: SourceHanSansCN;
  font-size: 30px;
  text-align: justify;
}
.pp2{
  font-family: SourceHanSansCN;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-align: justify;
}
.pp3{
  font-family: SourceHanSansCN;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.2px;
  text-align: justify;
  line-height: 24px;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
  margin-left: auto;
  margin-right: auto;
}

.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}



.contentBox {
  width: 61.25%;
  margin: 50px auto;
}
.count1{
  width: 70%;
  height: 100px;
  display: flex;

}


</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue